// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-field[data-v-6c7a7131] {\n  border-bottom: 1px solid #f2f4f4;\n}\n", ""]);
// Exports
module.exports = exports;
